import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom';
import useNav from '../../../../hooks/useNav';
import { useBoundStore } from '../../../../zustand';
import { Breadcrumb } from '../../../../components/ui/breadcrumb';
import { styles } from '../../../../styles/tailwind-config';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../../../../components/ui/table';
import Card from '../../../../components/portal/Card';
import { useQuery } from '@tanstack/react-query';
import axios from '../../../../lib/axios';
import { useAuth } from '../../../../context/AuthProvider';
import FilePreview, { Extension } from '../../../../components/portal/FilePreviewer';
import { AlertDialog, AlertDialogContent } from '../../../../components/ui/alert-dialog';
import { AlertDialogCancel } from '@radix-ui/react-alert-dialog';
import { XIcon } from 'lucide-react';
import { Trans, useLingui } from '@lingui/react/macro'

const Documents = () => {
    const { t } = useLingui()
    const { auth } = useAuth()
    const [searchParams, setSearchParams] = useSearchParams();
    const { setNav, nav } = useNav()

    const interventions = useBoundStore((state) => state.interventions)
    const intervention = interventions?.find((i)=>i.m_iINTERVENTIESID === parseInt(searchParams.get('interventionid') || ''))

    useEffect(()=>{
        setNav({...nav, title:t`Bill of materials - interventionid ${searchParams.get('interventionid')}`})
    }, [])

    const { data:projectDocuments, isLoading:isLoadingProjectDocuments } = useQuery<ProjectDocument[]>({
        queryKey: [`project-documents-${intervention?.m_iINTERVENTIESID}`],
        queryFn: async () => {
            const { data } = await axios.get(`intervention/projectdocuments?dbid=${auth.data?.databases[0].dbid}&interventionid=${intervention?.m_iINTERVENTIESID}`)
            return data
        }
    })

    const { data:interventionDocuments, isLoading:isLoadingInterventionDocuments } = useQuery<InterventionDocument[]>({
        queryKey: [`intervention-documents-${intervention?.m_iINTERVENTIESID}`],
        queryFn: async () => {
            const { data } = await axios.get(`intervention/interventiondocuments?dbid=${auth.data?.databases[0].dbid}&interventionid=${intervention?.m_iINTERVENTIESID}&callid$${intervention?.m_iCALLID}`)
            return data
        }
    })

    const [open_base64, setopen_base64] = useState<ProjectDocument | InterventionDocument | undefined>(undefined);

  return (
    <div className='p-4'>
        {open_base64 && 
        <AlertDialog open={true} onOpenChange={(v)=>{if(!v){setopen_base64(undefined)}}}>
            <AlertDialogContent className='w-full h-full max-h-screen overflow-auto max-w-[100vw] flex flex-col p-0 gap-0'>
                <div className='flex items-center justify-between h-10 px-2 py-4 border-b'>
                    <AlertDialogCancel asChild>
                        <button className='flex items-center justify-center w-8 h-8'>
                            <XIcon className='w-4 h-4'/>
                        </button>   
                    </AlertDialogCancel>
                </div>
                <div className='p-4 overflow-auto'>
                    <FilePreview base64={open_base64.m_bDOCUMENT} extension={'m_sFILENAME' in open_base64 ? open_base64.m_sFILENAME.split('.').pop()?.toLowerCase() as Extension : ('m_sDOCUMENTNAME' in open_base64 ? open_base64.m_sDOCUMENTNAME.split('.').pop()?.toLowerCase() as Extension : undefined)} />
                </div>
            </AlertDialogContent>
        </AlertDialog>
        }

        <Breadcrumb items={[{title:<Link to="/" className='underline'><Trans>Startpagina</Trans></Link>}, {title:<Link to="/" className='underline'>Interventionid {searchParams.get('interventionid')}</Link>}, {title:<Link to=""><Trans>Documenten</Trans></Link>}]}/>
        
        <h1 className={`${styles.h1} mt-2 mb-4`}><Trans>Documenten</Trans></h1>

        <div className='flex flex-col w-full gap-4'>
            {/* <Card
                title="Documenten voor deze interventie"
            >
                BLABLA
            </Card>

            <Card
                title="Foto's voor deze interventie"
            >
                BLABLA
            </Card> */}

            <Card
                title={t`Documenten voor Technische eenheid`}
            >
                {(!interventionDocuments && !isLoadingInterventionDocuments) && <p className='text-sm text-neutral-400'><Trans>Geen documenten gevonden</Trans></p>}
                {(!interventionDocuments && isLoadingInterventionDocuments) && <p className='text-sm text-neutral-400'><Trans>Bezig met laden...</Trans></p>}
                {interventionDocuments && interventionDocuments.length > 0 && 
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead><Trans>Bestandsnaam</Trans></TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {interventionDocuments.map((document)=>(
                            <TableRow onClick={()=>{setopen_base64(document)}} className='cursor-pointer' key={document.m_iINTERVENTIEDOCUMENTID}>
                                <TableCell>{document.m_sDOCUMENTNAME}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                }
            </Card>

            <Card
                title={t`Project documenten`}
            >
                {(!projectDocuments && !isLoadingProjectDocuments) && <p className='text-sm text-neutral-400'><Trans>Geen documenten gevonden</Trans></p>}
                {(!projectDocuments && isLoadingProjectDocuments) && <p className='text-sm text-neutral-400'><Trans>Bezig met laden...</Trans></p>}
                {projectDocuments && projectDocuments.length > 0 && 
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead><Trans>Bestandsnaam</Trans></TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {projectDocuments.map((document)=>(
                            <TableRow onClick={()=>{setopen_base64(document)}} className='cursor-pointer' key={document.m_iPROJECTDOCUMENTID}>
                                <TableCell>{document.m_sFILENAME}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                }
            </Card>
        </div>
    </div>
  )
}

export default Documents